// internal-deps
import BridgeSdk from "@swiggy-private/web-bridge-sdk";
import { customHandlers } from "@swiggy-private/checkout-core";

export const initBridgeSdk = () => {
    return new BridgeSdk(undefined, customHandlers).sdk;
};
